
import { ExternalLink } from "../../../../Utils/link-helper";
import styles from "./ExternalNavigationLinks.module.css";


export const ExternalNavigationLinks = ({ linkText, to,  styleName='default', color  }) => {
  const linkStyles = `${styles.navigationLinksContainer} ${styles[styleName]}`;
    return (
        <span className={linkStyles}>
             <ExternalLink color={color} href={to}>{linkText}</ExternalLink>
        </span>
       
    );
}
